"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
* Tencent is pleased to support the open source community by making SPA UI available.
* Copyright (C) 2019, a Tencent company. All rights reserved.
*/
var _default = function _default() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var closeButton = props.closeButton,
      onClose = props.onClose,
      _props$title = props.title,
      title = _props$title === void 0 ? '' : _props$title,
      _props$subTitle = props.subTitle,
      subTitle = _props$subTitle === void 0 ? '' : _props$subTitle,
      _props$headerAddition = props.headerAdditionalContent,
      headerAdditionalContent = _props$headerAddition === void 0 ? '' : _props$headerAddition,
      _props$type = props.type,
      type = _props$type === void 0 ? '' : _props$type,
      _props$iconType = props.iconType,
      iconType = _props$iconType === void 0 ? '' : _props$iconType;
  var iconDom = null;

  if (type === 'normal') {
    switch (iconType) {
      case 'success':
        iconDom = _react["default"].createElement("div", {
          className: "spaui-icon spaui-icon-big spaui-icon-big-success"
        });
        break;

      case 'tip':
        iconDom = _react["default"].createElement("div", {
          className: "spaui-icon spaui-icon-big spaui-icon-big-tip"
        });
        break;

      case 'warning':
        iconDom = _react["default"].createElement("div", {
          className: "spaui-icon spaui-icon-big spaui-icon-big-warning"
        });
        break;

      case 'error':
        iconDom = _react["default"].createElement("div", {
          className: "spaui-icon spaui-icon-big spaui-icon-big-error"
        });
        break;

      case 'remind':
        iconDom = _react["default"].createElement("div", {
          className: "spaui-icon spaui-icon-big spaui-icon-big-remind"
        });
        break;
    }
  }

  return _react["default"].createElement("div", null, closeButton ? _react["default"].createElement("button", {
    type: "button",
    className: "close",
    onClick: onClose
  }, _react["default"].createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")) : null, title || typeof title === 'number' ? _react["default"].createElement("h4", {
    className: "modal-title"
  }, iconDom ? _react["default"].createElement("div", null, iconDom, title) : title) : null, subTitle || typeof subTitle === 'number' ? _react["default"].createElement("h5", {
    className: "modal-sub-title"
  }, subTitle) : null, headerAdditionalContent);
};

exports["default"] = _default;